import styles from "./styles.module.css";

interface IProps {
  children: React.ReactNode;
}

const MainLayout = ({ children }: IProps) => {
  return <main className={styles.main}>{children}</main>;
};

export default MainLayout;
